<template>
  <div class="ParkexclusiveActivities">
    <div class="order-item-title">表单详情</div>
    <div class="smallbox boxShadow" @click="jump(info.welfareId)">
      <img :src="info.banner" alt="">
      <div class="content">
        <p class="titel textOver">{{info.title}}</p>
        <p class="exclusive m_t5 textOver">园区用户专享：{{info.discountLimit}}</p>
        <p class="welfare m_t5 textOver">福利来自：{{info.providerName}}</p>
        <p class="timeLimit m_t5 ">有效期限：{{info.beginTime | DateFilter}} 至 {{info.endTime | DateFilter}}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    info:{
      type: Object,
      default() {
        return{}
      },
    },
  },
  methods:{
    jump(id) {
      this.$router.push({ path: `/navigator/exclusiveActivitiesdetails/${id}`});
    },
  },
}
</script>
<style lang="scss" scoped>
.smallbox{
  width: 590px;
  flex: 1;
  height: 126px;
  display: flex;
  margin-right: 20px;
  cursor: pointer;
  img {
    width: 168px;
    height: 126px;
  }
}
.content{
  box-sizing: border-box;
  padding: 10px 0 0 20px;
  flex: 1;
  background-color: #fff;
}
.titel{
  color: #333;
  font-size: 20px;
  width: 400px;
}
.exclusive{
  color: red;
  font-size: 16px;
  line-height: 20px;
  width: 400px;
}
.timeLimit{
  font-size: 12px;
}
.welfare{
  font-size: 12px;
}
.m_t5{
  margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/orderDetails/ParkexclusiveActivities.vue